import { Cards, Container, Content } from "./styles";

import ImageOne from "../../images/image (6).png";
import ImageTwo from "../../images/image (5).png";
import Card from "../card";

const LaborLaw = () => {
  const description = [
    {
      text: "Assessoria preventiva para empresas e trabalhadores:",
    },
    {
      text: "Análise de contratos de trabalhos",
    },
    {
      text: "Adequação às normas trabalhistas",
    },
    {
      text: "Orientação sobre rotinas administrativas",
    },
    {
      text: "Avaliação e prevenção de riscos jurídicos",
    },
  ];

  const descriptionTwo = [
    {
      text: "Rescisão Direta e Indireta",
    },
    {
      text: "Pedido de demissão",
    },
    {
      text: "Reconhecimento de vínculo empregatício",
    },
    {
      text: "Pagamento de horas extras",
    },
    {
      text: "Intervalos intrajornada e interjornada",
    },
    {
      text: "Descanso Semanal Remunerado (DSR)",
    },
    {
      text: "Verbas rescisórias",
    },
    {
      text: "Assédio moral",
    },
    {
      text: "Indenizações diversas",
    },
  ];

  return (
    <Container>
      <Content>
        <h1>Direito Trabalhista</h1>
        <p>
          Atuamos de forma consultiva e contenciosa, garantindo segurança
          jurídica tanto para empregadores quanto para empregados.
        </p>

        <Cards>
          <Card
            image={ImageOne}
            title="Consultivo Trabalhista"
            description={description}
          />
          <Card
            image={ImageTwo}
            title="Contencioso Trabalhista"
            description={descriptionTwo}
          />
        </Cards>
      </Content>
    </Container>
  );
};

export default LaborLaw;
